export enum RateType {
    NotSelected = 0,
    HigherRate = 1,
    LowRate = 2,
}

export enum ErrorTypes { 
    ErrorWhileSaving = 1,
    BadRequest = 2,
    JSONParseError = 3,
    ConnectionError = 4,
}

/**
 * 
 * 
 * @export
 * @enum {number}
 */
export enum MarketingPreferenceCommunicationType {
    /// <summary>
    /// Post
    /// </summary>
    Post = 0,
    /// <summary>
    /// Telephone
    /// </summary>
    Telephone = 1,
    /// <summary>
    /// TextOrSMS
    /// </summary>
    TextOrSMS = 2,
    /// <summary>
    /// Email
    /// </summary>
    Email = 3,
  }
  

/**
 * Employment status types that the broker API understands.
 *
 * @enum {number}
 */
export enum TogetherAuctionDIPEmploymentStatusType {
    Init = 0,
    FullTime = 1,
    PartTime = 2,
    SelfEmployed = 3,
    InReceiptOfBenefits = 4,
    Retirement = 5,
    Unemployment = 6,
    Other = 7,
}

/**
 * Other employment types.
 *
 * @enum {number}
 */
export enum TogetherAuctionDIPPOtherEmploymentStatusType {
    Init = 0,
    CarersAllowance = 1,
    ChildBenefitPayments = 2,
    ChildTaxCredit = 3,
    DisabilityAllowance = 4,
    DSSPayments = 5,
    IncapacityAllowance = 6,
    IncomeSupport = 7,
    InvestmentIncome = 8,
    LifeAwardedInvalidityBenefit = 9,
    MaintenancePayments = 10,
    PrivatePension = 11,
    GrossRentalIncome = 12,
    SecondIncome = 13,
    Statepension = 14,
    TaxCredit = 15,
    ThirdIncome = 16,
    WorkingFamilyTaxCredit = 17,
    Yearlyrenewableinvaliditybenefit = 18,
    GrossAnnualOtherIncome = 19,
    AttendanceAllowance = 20,
    EmploymentandSupportAllowance = 21,
    JobSeekersAllowance = 22,
    IndustrialInjuriesBenefit = 23,
    PensionCredit = 24,
    PersonalIndependencePayment = 25,
    TrustIncome = 26,
    UniversalCredit = 27,
    WarPensions = 28,
    WidowedParentsAllowance = 29,
    Other = 30,
}

export enum TogetherAuctionDIPNonOtherIncomeTypes {
    InReceiptOfStateBenefits = 4,
    Retirement = 5,
    Unemployment = 6,
}

export enum TogetherAuctionDIPOtherIncomeType {
    NonOther = 1,
    Other = 2,
}

/**
 * UI-specific income types.
 *
 * @export
 * @enum {number}
 */
export enum TogetherAuctionDIPIncomeTypeBroad {

    Init = 0,
    FullTime = 1,
    PartTime = 2,
    SelfEmployed = 3,
    Pension = 5,
    Investments = 7,
    InReceiptOfStateBenefits = 4,
    RentalIncome = 8,
    ImCurrentlyUnemployed = 6,
}


/**
 * Broker API-specific code for payment period.
 *
 * @export
 * @enum {number}
 */
export enum TogetherAuctionDIPPaymentPeriod {
    Init = 0,
    Weekly = 1,
    Fortnightly = 2,
    FourWeekly = 3,
    Monthly = 4,
}


/**
 * The state of the entity state service itself.
 *
 * @export
 * @enum {number}
 */
export enum TogetherAuctionDIPServiceState {
    Idle = 0,
    PerformingOperation = 1,
    PerformedOperationSuccess = 1,
    PerformedOperationError = 2,
}

/**
 * The state of an entity for the entity state service.
 *
 * @export
 * @enum {number}
 */
export enum TogetherAuctionDIPEntityState {
    New = 0,
    Saved = 1,
    OperationPending = 2,
    OperationIdle = 3,
    Deleted = 4,
    Error = -1,
}

/**
 * The operation for an entity within the entity state service.
 *
 * @export
 * @enum {number}
 */
export enum TogetherAuctionDIPEntityOperation {
    Get = 0,
    Save = 1,
    Delete = 2,
    Find = 3,
    Try = 4,
    None = 5,
    Match = 6,
    ForceCollapse = 7,
    ForceValidate = 8,
}

/**
 * The type of the entity.
 *
 * @export
 * @enum {number}
 */
export enum TogetherAuctionDIPEntityType {
    LoanDetails = 0,
    ApplicantsPersonal = 1,
    EmploymentDetails = 2,
    SecurityDetails = 3,
    SolicitorDetails = 4,
    QuoteDetails = 5,
    Address = 6,
    SubmitDIP = 7,
    SubmitQuote = 8,
    Detail = 9,
    Stage = 10,
    SubmitCertificate = 11,
    GetRecap = 12,
    ApplicantsBusiness = 13,
    JWT = 14,
    CompanyLookup = 15,
    ApplicantAddress = 16,
    AddressMatch = 17,
    ExistingCharge = 18,
    Requote = 19,
}

export enum TogetherAuctionDIPStageType {
    PreApproval = 100,
    Apply = 101,
    Confirmation = 102,
    LoanDetails = 103,
    ApplicantDetails = 104,
    IncomeDetails = 105,
    PropertyDetails = 106,
    OutcomeDetails = 107,
    AdditionalLoanDetails = 108,
    SolicitorsDetails = 109,
    ApplicationSubmitted = 110,
    RetrieveDIP = 111,
    Recap = 112,
    Edit = 113,
}


/**
 * Dip submission request status
 * Used to track where a dip submission is up to, to try
 * and prevent multiple submission
 *
 * @export
 * @enum {number}
 */
export enum SubmissionRequestStatus {
    Uninitialised = 0,
    Complete = 1,
    Initialised = 2,
    Inprogress = 3,
}


export enum TogetherAuctionDIPApplicantIterationType {
    Init = 0,
    Forward = 1,
    Back = 2,
}
